import { httpClient } from '../../lib/utils';
import { envValue } from '../../config/envUtils';

const SBEM_CLEAR_CACHE_URL = envValue('SBEM_CLEAR_CACHE_URL');

/**
 * Clears the SBEM BFF cache for tracking hook content associated with the given hotel and chain.
 * Fire-and-forget: not awaited by callers, consistent with other clearSbem*Cache functions.
 * @param chainId
 * @param hotelId
 * @returns {Promise}
 */
export function clearSbemTrackingHookContentCache(chainId, hotelId) {
    return httpClient.post(SBEM_CLEAR_CACHE_URL, { chainId, hotelId, keyType: 'trackingHookContent' });
}

/**
 * Clears the SBEM BFF cache for custom content associated with the given hotel and chain.
 * Fire-and-forget: not awaited by callers, consistent with other clearSbem*Cache functions.
 * @param chainId
 * @param hotelId
 * @returns {Promise}
 */
export function clearSbemCustomContentCache(chainId, hotelId) {
    return httpClient.post(SBEM_CLEAR_CACHE_URL, { chainId, hotelId, keyType: 'customContent' });
}



// WEBPACK FOOTER //
// ./src/services/AssetService.js